import { useEffect, useState } from "react";
import DefaultLayout from "../layout/DefaultLayout";
import { useAuth } from "../Auth/AuthProvider";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../Auth/constansts";

export default function Signup() {

    const auth = useAuth();
    const goTo = useNavigate();
    const params = useParams();

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [code, setCode] = useState("");
    const [errorResponse, setErrorResponse] = useState("");


    useEffect(() => {
        if (typeof params["token"] === "string") {
            setCode(params["token"]);
        }
    }, [params]);

    async function handleSubmit(e) {
        e.preventDefault();
        try {
            const response = await fetch(`${API_URL}/register`, {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name,
                    email,
                    password,
                    code
                }),
            });
            if (response.ok) {
                goTo("/dashboard");
            }
            else {
                setErrorResponse("The user was not created");
            }
        } catch (error) {
            setErrorResponse("System Error");
        }
    }

    if (auth.isAuthenticated) {
        return <Navigate to="/dashboard" />
    }

    return (
        <>
            <DefaultLayout />
            <form className="form" onSubmit={handleSubmit}>
                <h1>Signup</h1>
                {!!errorResponse && <div className="errorMessage">{errorResponse}</div>}
                <label>Name</label>
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} />

                <label>Email</label>
                <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} />

                <label>Password</label>
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />

                <label>Code</label>
                <input type="text" value={code} onChange={(e) => setCode(e.target.value)} />

                <button>Create user</button>
            </form>
        </>
    );
}